import { render } from "./StarLogo.vue?vue&type=template&id=48a95873&scoped=true"
import script from "./StarLogo.vue?vue&type=script&lang=js"
export * from "./StarLogo.vue?vue&type=script&lang=js"

import "./StarLogo.vue?vue&type=style&index=0&id=48a95873&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a95873"]])

export default __exports__